"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHSJZS = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var react_router_dom_1 = require("react-router-dom");
var hotlinks_1 = require("../quotetable/hotlinks");
var quotetable_1 = require("../quotetable");
/**
 * 沪深京指数
 * @returns
 */
function PageHSJZS() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash;
    return (react_1.default.createElement("div", { className: "hsjzs" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        hash != '#index_zzzs' && react_1.default.createElement("div", { className: "hlmzb scf" },
            react_1.default.createElement("div", { className: "hl" },
                hash == '#index_sh' &&
                    react_1.default.createElement(hotlinks_1.HSJHotLinks, null),
                (hash == '#index_sz' || hash == '#index_components') &&
                    react_1.default.createElement(hotlinks_1.SZZSHotLinks, null))),
        react_1.default.createElement(quotetable_1.QuoteTable, null)));
}
exports.PageHSJZS = PageHSJZS;
